import { styled } from '@mui/material'
import { TTheme } from '@/core/theme'

export const FilterButtonContainer = styled('button')<{
    theme?: TTheme
    disabled?: boolean
    isActive?: boolean
}>`
    display: flex;
    align-items: center;
    gap: 9px;
    height: 42px;
    padding: 6px 16px;
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.colors.semantic.contentSeparator};
    background: ${({ theme }) => theme.colors.semantic.filterUnActive};
    color: ${({ theme }) => theme.colors.greys[900]};
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
    transition:
        background 0.2s,
        color 0.2s;

    &:hover {
        background: ${({ theme, disabled }) =>
            !disabled && theme.colors.greys[100]};
    }

    .filter-icon {
        display: flex;
        align-items: center;
        font-size: 1.2em;
    }

    svg {
        margin-bottom: ${({ isActive }) => (isActive ? 3 : 0)}px;
    }

    .filter-status {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 6px;

        &-count {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 2px;
        }
    }
`
